export default "__VITE_ASSET__47a4176d__"